<template>
    <b-container fluid>
        <b-row>
            <b-col cols="3" class="py-2">
                <label for="title">Nombre o palabras clave</label>
                <app-form-input
                    type="text"
                    size="sm"
                    id="name"
                    v-model="filters.name"
                ></app-form-input>
            </b-col>
            <b-col cols="3">
                <app-form-input
                    label="Desde"
                    type="date"
                    v-model="filters.from"
                ></app-form-input>
            </b-col>
            <b-col cols="3">
                <app-form-input
                    label="Hasta"
                    type="date"
                    v-model="filters.to"
                ></app-form-input>
            </b-col>
            <b-col cols="3" class="right-spaced mt-4">
                <b-btn variant="primary" title="filtrar" @click="filter">
                    <i class="fa fa-filter"></i>
                </b-btn>
                <b-btn variant="secondary" title="limpiar" @click="clear">
                    <i class="fa fa-times"></i>
                </b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
            from: '',
            to: '',
        },
    }),
    methods: {
        filter() {
            this.$emit('filters', this.filters)
        },
        clear() {
            this.filters.from = ''
            this.filters.to = ''
            this.filters.name = ''
            this.$emit('clear')
        },
    },
}
</script>
